import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {PricingPlanSchema} from './pricingPlan'

export const PricingOptionSchema = buildEntrySchemaFor('pricingOption', {
  fields: z.lazy(() =>
    z.object({
      label: z.string(),
      plans: z.array(PricingPlanSchema),
    }),
  ),
})

export type PricingOption = z.infer<typeof PricingOptionSchema>
